import type { ChildAppConfig } from '@shared/app-config'
import type { AxiosInstance } from 'axios'
import type { FormResult, FormState } from './types'
import { getApiRoutes, resolveRoute } from '@shared/api/routes'
import axios from 'axios'

export function createForm(appConfig: ChildAppConfig, api: AxiosInstance) {
  const formApi = {
    get: async () => {
      try {
        return (await api.get<FormState>(resolveRoute(getApiRoutes().artifacts.state, { artifactId: appConfig.context.resourceId }))).data
      }
      catch (error) {
        if (axios.isAxiosError(error)) {
          return {
            data: {
              firstName: 'Test',
              lastName: 'Prefill',
              email: 'john.smith@example.com',
              phone: '+1 (555) 123-4567',
              caseType: 'corporate',
              caseDetails: 'I need assistance with reviewing a merger agreement between two technology companies. The deal is valued at approximately $5M and includes intellectual property considerations.',
              urgency: 'medium',
              deadline: '2025-04-15',
              existingClient: true,
              termsAgree: true,
            },
            status: 'waiting',
          }
        }
      }
    },
    submit: async (data: FormData | Record<string, unknown>): Promise<FormResult> => {
      try {
        return (await api.post<FormResult>(resolveRoute(getApiRoutes().artifacts.state, { artifactId: appConfig.context.resourceId }), data)).data
      }
      catch (error) {
        if (axios.isAxiosError(error)) {
          // TODO: Convert error response to FormResult here
          console.warn('Mocking form submit instead of doing an error')
          if (Math.random() > 0.5) {
            return {
              success: false,
              message: 'Please correct the errors in your submission',
              errors: {
                firstName: 'This field is required',
                email: 'Please enter a valid email address',
                caseDetails: 'Please provide more details (minimum 50 characters)',
                termsAgree: 'You must agree to the terms and conditions',
              },
            }
          }
          else {
            return {
              success: true,
              message: 'Your case has been submitted successfully. Reference number: LCF-20250326-47821',
            }
          }
        }
        throw error
      }
    },
  }

  return formApi
}
